@if (options()?.length) {
  <div
    class="mcm-segmented-control"
    [ngClass]="modifiers()">
    <ion-segment
      (ionChange)="onSegmentValueChanged($event)"
      mode="ios"
      [value]="value()"
      [disabled]="disabled()">

      @for (option of options(); track option.id) {
        <ion-segment-button
          [value]="option.id"
          [disabled]="option.disabled"
          [ngClass]="option.extraClasses"
          dataId="qa"
          [mcmDataAttr]="{ id: option.qaId }">
          <span class="mcm-segmented-control__content">
            @if (option.image) {
              <ion-img [src]="option.image" />
            }

            @if (option.icon) {
              <ion-icon [icon]="option.icon" />
            }

            @if (option.label) {
              <ion-label>{{ option.label | translate }}</ion-label>
            }
          </span>
        </ion-segment-button>
      }
    </ion-segment>
  </div>
}
